import {useEffect, useMemo, useState} from 'react'
import {Button, Col, Form, Row, Spinner} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {MultiSelect} from 'react-multi-select-component'
import {create as uploadAttachment} from 'src/api/modules/file'
import {getRoleFlagList} from 'src/api/modules/master-data/master_2'
import { InputFile } from 'src/app/components/InputFile'
import {ActionIcon, PopoverText} from 'src/components'
import {CustomModal} from 'src/components/CustomModal'
import {useRoleUser} from 'src/hooks/useRoleUser'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {appSelector} from 'src/redux/slices/appSlices'
import {authSelector} from 'src/redux/slices/authSlices'
import {
  orderSelector,
  setAttachments,
  setOrder,
  setShowAttachmentModal,
} from 'src/redux/slices/orderSlices'
import {TOrder, TOrderChildern} from 'src/redux/types'
import {fetchAttachments} from 'src/services/fetcher'
import {deleteAttachment} from 'src/services/mutations'
import dateformat from 'src/utils/dateformat'
import swal from 'sweetalert'

export const AttachmentsTable = () => {
  const {t} = useTranslation()
  const {user} = useAppSelector(authSelector)
  const {selectedMenu} = useAppSelector(appSelector)
  const {attachments, attachment_type, order} = useAppSelector(orderSelector)
  const {isAdmin} = useRoleUser()
  const dispatch = useAppDispatch()

  const handleDeleteAttachment = async (attachmentId: number) => {
    try {
      const confirm = await swal({
        title: `${t('Are you sure?')}`,
        icon: 'warning',
        buttons: [`${t('Tidak')}`, `${t('Yes')}`],
        dangerMode: true,
      })

      if (confirm) {
        await deleteAttachment(attachmentId)

        // Refetch
        const orderId = (order as TOrder).id.toString()
        const {data} = await fetchAttachments({attachment_type, attach_parent: +orderId})
        dispatch(setAttachments(data.data))
      }
    } catch (error: any) {
      swal({
        title: error?.message ?? 'Internal server error',
        icon: 'error',
      })
    }
  }

  const handleDownloadAttachment = async (filePath: string) => {
    // window.open(filePath + `&token=${localStorage.getItem('token')}`)
    const res = await fetch(filePath, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    window.open(url);

  }

  function handleShowRoleName(role: any) {
    let temp = ''
    role.forEach((element: any, index: any) => {
      if (index + 1 == role.length) temp = temp + element
      else temp = temp + element + ', '
    })
    return temp
  }

  return (
    <div className='table-responsive bdr mt-6'>
      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
        <thead className='fw-bold border-bottom'>
          <tr className=''>
            <th className='text-center px-2'>{t('order-noo')}</th>
            <th className='text-center'>{t('order-keterangan')}</th>
            <th className='text-center'>{t('order-tglUpload')}</th>
            {/* <th className='text-center'>{t('User Code')}</th> */}
            <th className='text-center'>{t('order-user')}</th>
            <th className='text-center'>{t('Akses Role')}</th>
            <th className='text-center'>{t('order-aksi')}</th>
          </tr>
        </thead>

        {attachments.map((data: any, _index: any) => {
          const isOwner = user?.credential.role_flag === data.user_role_flag

          return (
            <tbody key={data?.id ?? _index}>
              <tr className=''>
                <td className='text-center'>
                  <label>{_index + 1}</label>
                </td>
                <td className='text-center'>
                  <label>{data.description}</label>
                </td>
                <td className='text-center'>
                  <label>{dateformat(data.updated_at)}</label>
                </td>
                {/* <td className='text-center'>
                  <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
                </td> */}
                <td className='text-center'>
                  {data.user?.customer_code == null ? (
                    <label>{data.user?.name}</label>
                  ) : (
                    <label>{data.user?.customer?.name}</label>
                  )}
                </td>
                <td className='text-center'>
                  {data.private ? (
                    data.roles.length > 0 ? (
                      <PopoverText
                        content={handleShowRoleName(data.roles)}
                        index={_index}
                        className='desc-slice'
                      />
                    ) : (
                      'Private'
                    )
                  ) : (
                    'Public'
                  )}
                </td>
                <td className='text-center'>
                  <ActionIcon
                    className='me-1'
                    title={t('unduh')}
                    iconPath='/media/icons/duotune/arrow-down-square-fill.svg'
                    onClick={() => handleDownloadAttachment(data.file_path)}
                  />
                  {(selectedMenu?.attachment_delete || isOwner) && (
                    <ActionIcon
                      className={`${isAdmin ? 'd-none' : ''}`}
                      title={t('Hapus')}
                      iconPath='/media/icons/duotune/trash-fill.svg'
                      onClick={() => handleDeleteAttachment(data.id)}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          )
        })}
      </table>
    </div>
  )
}

export const DownloadAttachment = () => {
  const {t} = useTranslation()
  const {isCustomer} = useRoleUser()
  const {attachment_type, order} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()

  const [description, setDescription] = useState('')
  const [isPrivate, setIsPrivate] = useState(false)
  const [tempRole, setTempRole] = useState([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [fullRole, setFullRole] = useState([])
  const [files, setFiles] = useState({file: null})

  const clearInputUpload = () => {
    const input1 = document.getElementById('uploadketerangan') as HTMLInputElement
    const input2 = document.getElementById('upload') as HTMLInputElement
    const inputPrivate = document.getElementById('isPrivate') as HTMLInputElement

    input1.value = ''
    input2.value = ''
    inputPrivate.checked = false

    setFiles({file: null})
    setDescription('')
    setIsPrivate(false)
    setTempRole([])
  }

  const handleUpload = async () => {
    try {
      setBtnLoading(true)

      let file = files.file
      let formdata = new FormData()
      let temparray: any[] = []
      if (tempRole.length > 0) {
        tempRole.forEach((data: any) => {
          temparray.push(data.value)
        })
      }

      let orderId = '';

      // Define order id
      if (attachment_type == 'amandemen') {
        const _data = order as TOrderChildern
        orderId = _data.amendment_orders ? _data.amendment_orders[0]?.id : _data.id
      } else {
        orderId = (order as TOrder).id.toString()
      }

      formdata.append('file_r', file!)
      formdata.append('attach_parent', orderId)
      formdata.append('description', description!)
      formdata.append('private', isPrivate.toString())
      formdata.append('roles', JSON.stringify(temparray))
      formdata.append('credentials', localStorage.getItem('credential')!)

      // Request upload attachment
      const response = await uploadAttachment(attachment_type, formdata)

      // Show error message
      if (response.data.error) {
        const title = t(response.data.message)
        swal({title, icon: 'error'})
        return
      }

      // Refetch
      if (attachment_type == 'amandemen') {
        const orderItemId = (order as TOrder).id.toString()
        const {data} = await fetchAttachments({attachment_type, attach_parent: +orderId})
        const {data: data2} = await fetchAttachments({attachment_type: 'order-item', attach_parent: +orderItemId})
        dispatch(setAttachments([...data2.data, ...data.data]))
      } else {
        const {data} = await fetchAttachments({attachment_type, attach_parent: +orderId})
        dispatch(setAttachments(data.data))
      }

      // Reset
      clearInputUpload()

      // Show success message
      const title = t('document uploaded successfully')
      swal({title, icon: 'success'})
    } catch (error: any) {
      // Show error message
      const title = t(error.response.data.message)
      swal({title, icon: 'error'})
    } finally {
      setBtnLoading(false)
    }
  }

  const getAllRoleList = async () => {
    const res = await getRoleFlagList()
    setFullRole(res.data.data)
  }

  useEffect(() => {
    getAllRoleList()
  }, [])

  return (
    <Row>
      <Col sm={6}>
        <table className='mb-3'>
          <tr>
            <td style={{width: '120px'}}>
              <h6>{t('order-fileUnggah')}</h6>
            </td>
            <td className='w-75'>
              <InputFile
                  setFileName={(_: string) => {}}
                  setFiles={setFiles}
                  isBase64={false}
              />
            </td>
          </tr>
        </table>
        <table className='mb-3'>
          <tr>
            <td style={{width: '120px'}}>
              <h6>{t('order-keterangan')}</h6>
            </td>
            <td className='w-75'>
              <Form.Control
                type='text'
                id='uploadketerangan'
                placeholder={t('order-keterangan')}
                onChange={(e: any) => setDescription(e.target.value)}
              />
            </td>
          </tr>
        </table>
        <table className='mb-3' hidden={!isCustomer ? false : true}>
          <tr>
            <td>
              <h6 className='me-11'>{t('Private')}</h6>
            </td>
            <td className='w-75 d-flex justify-content-start'>
              <Form.Check
                reverse
                name='isPrivate'
                type='checkbox'
                className='mt-5 mb-2'
                onClick={() => {
                  setIsPrivate(!isPrivate)
                  setTempRole([])
                }}
                id='isPrivate'
              />
            </td>
          </tr>
        </table>
        <table className='mb-3' hidden={isPrivate ? false : true}>
          <tr>
            <td style={{width: '120px'}}>
              <h6>{t('Akses Role')}</h6>
            </td>
            <td className='w-75' style={{maxWidth: '274px'}}>
              <MultiSelect
                key={isPrivate.toString()}
                options={fullRole?.map((item: any) => {
                  return {label: item.label, value: item.value}
                })}
                value={tempRole}
                onChange={(e: any) => setTempRole(e)}
                labelledBy='Select'
              />
            </td>
          </tr>
        </table>
        <div className='d-flex justify-content-end'>
          <Button
            variant='primary'
            className='w-100'
            onClick={() => handleUpload()}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>
      </Col>
    </Row>
  )
}

export const AttachmentModal = () => {
  const {t} = useTranslation()
  const {showAttachmentModal, attachments, attachment_type, order, isDownloadOnly} =
    useAppSelector(orderSelector)
  const dispatch = useAppDispatch()
  const {isCustomer} = useRoleUser()

  const isPurchase = useMemo(() => {
    if (!order) return false
    const selectedOrder = order as TOrder
    return selectedOrder?.regarding === 'PO001'
  }, [order])

  const modalTitle = useMemo(() => {
    if (!order) return ''
    if (attachment_type === 'header') return t('File Box')

    const {province, city, product_name, request_quantum} = order as TOrderChildern
    const region_name = province ? province.region_name : ''
    const city_name = city ? city.city_name : ''
    // return `${region_name}, ${city_name} | ${product_name} | ${request_quantum} Ton`
    return [
      [
        region_name,
        city_name
      ].filter((x) => x).join(", "),
      product_name,
      request_quantum ? request_quantum + " Ton" : null
    ].filter((x) => x).join(" | ")
  }, [attachment_type])

  const handleHide = () => {
    dispatch(setOrder(null))
    dispatch(setShowAttachmentModal(false))
  }

  return (
    <CustomModal
      title={modalTitle}
      show={showAttachmentModal}
      centered
      size='lg'
      onHide={handleHide}
    >
      {!isDownloadOnly && <DownloadAttachment />}
      {!attachments.length ? <div className='text-center p-4'>No Attachment</div> : <AttachmentsTable />}
    </CustomModal>
  )

  //   return (
  //     <Modal
  //       size='lg'
  //       show={showAttachmentModal}
  //       onHide={handleHide}
  //       backdrop='static'
  //       keyboard={false}
  //       centered
  //     >
  //       <Modal.Header closeButton>
  //         <Modal.Title>
  //           {fileBox?.product_name
  //             ? (fileBox.province ? fileBox.province?.region_name : '') +
  //               (fileBox.city ? ', ' + fileBox.city?.city_name : '') +
  //               (fileBox.province ? ' | ' : '') +
  //               fileBox.product_name +
  //               (fileBox.request_quantum ? ' | ' + fileBox.request_quantum + ' Ton' : '')
  //             : t('File Box')}
  //         </Modal.Title>
  //       </Modal.Header>
  //       <Modal.Body>
  //         {is_amandemen == 'false' ? (
  //           <>
  //             {!downloadOnly && (
  //               <Row>
  //                 <Col sm={6}>
  //                   <table className='mb-3'>
  //                     <tr>
  //                       <td style={{width: '120px'}}>
  //                         <h6>{t('order-fileUnggah')}</h6>
  //                       </td>
  //                       <td className='w-75'>
  //                         <Form.Control
  //                           type='file'
  //                           accept='application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg'
  //                           id='upload'
  //                           onChange={(e: any) => handleFile(e)}
  //                         />
  //                       </td>
  //                     </tr>
  //                   </table>
  //                   <table className='mb-3'>
  //                     <tr>
  //                       <td style={{width: '120px'}}>
  //                         <h6>{t('order-keterangan')}</h6>
  //                       </td>
  //                       <td className='w-75'>
  //                         <Form.Control
  //                           type='text'
  //                           id='uploadketerangan'
  //                           placeholder={t('order-keterangan')}
  //                           onChange={(e: any) => setDescription(e.target.value)}
  //                         />
  //                       </td>
  //                     </tr>
  //                   </table>
  //                   <table
  //                     className='mb-3'
  //                     hidden={roleUser != null && roleUser != 'null' ? false : true}
  //                   >
  //                     <tr>
  //                       <td>
  //                         <h6 className='me-11'>{t('Private')}</h6>
  //                       </td>
  //                       <td className='w-75 d-flex justify-content-start'>
  //                         <Form.Check
  //                           reverse
  //                           name='isPrivate'
  //                           type='checkbox'
  //                           className='mt-5 mb-2'
  //                           onClick={() => {
  //                             setIsPrivate(!isPrivate)
  //                             setTempRole([])
  //                           }}
  //                           id='isPrivate'
  //                         />
  //                       </td>
  //                     </tr>
  //                   </table>
  //                   <table className='mb-3' hidden={isPrivate ? false : true}>
  //                     <tr>
  //                       <td style={{width: '120px'}}>
  //                         <h6>{t('Akses Role')}</h6>
  //                       </td>
  //                       <td className='w-75' style={{maxWidth: '274px'}}>
  //                         <MultiSelect
  //                           key={isPrivate.toString()}
  //                           options={fullRole?.map((item: any) => {
  //                             return {label: item.label, value: item.value}
  //                           })}
  //                           value={tempRole}
  //                           onChange={(e: any) => setTempRole(e)}
  //                           labelledBy='Select'
  //                         />
  //                       </td>
  //                     </tr>
  //                   </table>
  //                   <div className='d-flex justify-content-end'>
  //                     <Button
  //                       variant='primary'
  //                       className='w-100'
  //                       onClick={() => handleUpload()}
  //                       disabled={btnLoading}
  //                     >
  //                       {btnLoading ? (
  //                         <Spinner animation='border' variant='light' size='sm' />
  //                       ) : (
  //                         t('order-kirim')
  //                       )}
  //                     </Button>
  //                   </div>
  //                 </Col>
  //                 <Col sm={6} className='mt-3'>
  //                   {isexceed ? <span className='text-danger'>{t('File Exceed 2MB')}</span> : <></>}
  //                 </Col>
  //               </Row>
  //             )}

  //             {allFile.length < 1 || allFile.length == undefined ? (
  //               <></>
  //             ) : (
  //               <div className='table-responsive mt-4 bdr'>
  //                 <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
  //                   <thead className='fw-bold border-bottom'>
  //                     <tr className=''>
  //                       <th className='text-center px-2'>{t('order-noo')}</th>
  //                       <th className='text-center'>{t('order-keterangan')}</th>
  //                       <th className='text-center'>{t('order-tglUpload')}</th>
  //                       <th className='text-center'>{t('User Code')}</th>
  //                       <th className='text-center'>{t('order-user')}</th>
  //                       <th className='text-center'>{t('Akses Role')}</th>
  //                       <th className='text-center'>{t('order-aksi')}</th>
  //                     </tr>
  //                   </thead>
  //                   {allFile.map((data: any, _index: any) => (
  //                     <tbody key={data?.id ?? _index}>
  //                       <tr className=''>
  //                         <td className='text-center'>
  //                           <label>{_index + 1}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.description}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.updated_at}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           {data.user?.customer_code == null ? (
  //                             <label>{data.user?.name}</label>
  //                           ) : (
  //                             <label>{data.user?.customer?.name}</label>
  //                           )}
  //                         </td>
  //                         <td className='text-center'>
  //                           {data.private ? (
  //                             data.roles.length > 0 ? (
  //                               <PopoverText
  //                                 content={handleShowRoleName(data.roles)}
  //                                 index={_index}
  //                                 className='desc-slice'
  //                               />
  //                             ) : (
  //                               'Private'
  //                             )
  //                           ) : (
  //                             'Public'
  //                           )}
  //                         </td>
  //                         <td className='text-center'>
  //                           <button
  //                             className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
  //                             data-bs-toggle='tooltip'
  //                             data-bs-placement='top'
  //                             data-bs-trigger='hover'
  //                             title={t('unduh')}
  //                             onClick={() =>
  //                               window.open(
  //                                 data.file_path + `&token=${localStorage.getItem('token')}`
  //                               )
  //                             }
  //                           >
  //                             <KTSVG
  //                               path='/media/icons/duotune/arrow-down-square-fill.svg'
  //                               className='svg-icon-3'
  //                             />
  //                           </button>
  //                           {(accsessDelete || CheckSameIDAttachment(data.id)) && (
  //                             <button
  //                               onClick={() => deleteAttachment(data.id)}
  //                               className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm`}
  //                               data-bs-toggle='tooltip'
  //                               data-bs-placement='top'
  //                               data-bs-trigger='hover'
  //                               title={t('Hapus')}
  //                             >
  //                               <KTSVG
  //                                 path='/media/icons/duotune/trash-fill.svg'
  //                                 className='svg-icon-3'
  //                               />
  //                             </button>
  //                           )}
  //                         </td>
  //                       </tr>
  //                     </tbody>
  //                   ))}
  //                 </table>
  //               </div>
  //             )}
  //           </>
  //         ) : (
  //           <>
  //             {allFile.length < 1 || allFile.length == undefined ? (
  //               <></>
  //             ) : (
  //               <div className='table-responsive mt-4 bdr'>
  //                 <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
  //                   <thead className='fw-bold border-bottom'>
  //                     <tr className=''>
  //                       <th className='text-center px-2'>{t('order-noo')}</th>
  //                       <th className='text-center'>{t('order-keterangan')}</th>
  //                       <th className='text-center'>{t('order-tglUpload')}</th>
  //                       <th className='text-center'>{t('User Code')}</th>
  //                       <th className='text-center'>{t('order-user')}</th>
  //                       <th className='text-center'>{t('Akses Role')}</th>
  //                       <th className='text-center'>{t('order-aksi')}</th>
  //                     </tr>
  //                   </thead>
  //                   {allFile.map((data: any, _index: any) => (
  //                     <tbody key={data?.id ?? _index}>
  //                       <tr className=''>
  //                         <td className='text-center'>
  //                           <label>{_index + 1}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.description}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.updated_at}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           <label>{data.user?.customer_code || data.user?.nama_pengguna}</label>
  //                         </td>
  //                         <td className='text-center'>
  //                           {data.user?.customer_code == null ? (
  //                             <label>{data.user?.name}</label>
  //                           ) : (
  //                             <label>{data.user?.customer?.name}</label>
  //                           )}
  //                         </td>
  //                         <td className='text-center'>
  //                           {data.private ? (
  //                             data.roles.length > 0 ? (
  //                               <PopoverText
  //                                 content={handleShowRoleName(data.roles)}
  //                                 index={_index}
  //                                 className='desc-slice'
  //                               />
  //                             ) : (
  //                               'Private'
  //                             )
  //                           ) : (
  //                             'Public'
  //                           )}
  //                         </td>
  //                         <td className='text-center'>
  //                           <button
  //                             className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
  //                             data-bs-toggle='tooltip'
  //                             data-bs-placement='top'
  //                             data-bs-trigger='hover'
  //                             title={t('unduh')}
  //                             onClick={() =>
  //                               window.open(
  //                                 data.file_path + `&token=${localStorage.getItem('token')}`
  //                               )
  //                             }
  //                           >
  //                             <KTSVG
  //                               path='/media/icons/duotune/arrow-down-square-fill.svg'
  //                               className='svg-icon-3'
  //                             />
  //                           </button>
  //                           {(accsessDelete || CheckSameIDAttachment(data.id)) && (
  //                             <button
  //                               onClick={() => deleteAttachment(data.id)}
  //                               className={`btn btn-icon btn-bg-light btn-active-color-primary btn-sm ${
  //                                 roleUser == 'admin' ? 'd-none' : ''
  //                               }`}
  //                               data-bs-toggle='tooltip'
  //                               data-bs-placement='top'
  //                               data-bs-trigger='hover'
  //                               title={t('Hapus')}
  //                             >
  //                               <KTSVG
  //                                 path='/media/icons/duotune/trash-fill.svg'
  //                                 className='svg-icon-3'
  //                               />
  //                             </button>
  //                           )}
  //                         </td>
  //                       </tr>
  //                     </tbody>
  //                   ))}
  //                 </table>
  //               </div>
  //             )}
  //           </>
  //         )}
  //       </Modal.Body>
  //     </Modal>
  //   )
}
